import { app } from "../serviceLMS";
import { GET_QUIZ_ATTEMPTS, GET_QUIZ_ATTEMPT_DETAILS, GET_QUIZ_ATTEMPT_META } from "../URLs";

export const fetchQuizAttemptMeta = async (userId, courseId) => {
  try {
    const response = await app.get(GET_QUIZ_ATTEMPT_META(userId, courseId));
    return response.data?.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Could not load quiz meta.");
  }
};

export const fetchQuizAttemptDetails = async (userId, courseId, attemptId) => {
  try {
    const response = await app.get(GET_QUIZ_ATTEMPT_DETAILS(userId, courseId, attemptId));
    return response.data?.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Could not load quiz results.");
  }
};